import { borderRadius } from '@toggle/design-system';
import styled from 'styled-components';

export const Dot = styled.span<{ $color: string }>`
  width: 8px;
  height: 8px;
  ${borderRadius.rFull};
  background-color: ${props => props.$color};
`;
